import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BadgesContextualTitle, NumberOfBadge, NumberOfPills, PillsContextualTitle, TagPills, UiKits } from "../../../Constants/Constants";
import CommonBadges from "./CommonBadges/CommonBadges";
import { BadgeIconData, BadgesContextualSubTitle, BadgesData, NumberBadgeSubTitle, NumberPillsSubTitle, PillsContextualSubTitle } from "../../../Data/UiKits/Tag&Pills";
import BadgeHeading from './BadgeHeading'
import BadgeButton from './BadgeButton'

const TagAndPillsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TagPills} parent={UiKits} />
      <Container fluid>
        <Row>
          <CommonBadges title={BadgesContextualTitle} span={BadgesContextualSubTitle} data={BadgesData}/>
          <CommonBadges title={PillsContextualTitle} span={PillsContextualSubTitle} data={BadgesData} roundedPills/>
          <CommonBadges title={NumberOfBadge} span={NumberBadgeSubTitle} data={BadgesData} number/>
          <CommonBadges title={NumberOfPills} span={NumberPillsSubTitle} data={BadgesData} number className='rounded-circle badge-p-space'/>
          <CommonBadges title={NumberOfPills} span={NumberPillsSubTitle} data={BadgeIconData} icon/>
          <CommonBadges title={NumberOfPills} span={NumberPillsSubTitle} data={BadgeIconData} icon className='rounded-circle p-2'/>
          <BadgeHeading/>
          <BadgeButton/>
        </Row>
      </Container>
    </>
  );
};
export default TagAndPillsContainer;
